/* unplugin-vue-components disabled */import script from "./Disclaimer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Disclaimer.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__